import { NgModule } from '@angular/core';
import { ClearanceItemTagComponent } from '.';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    imports:[
        ReactiveFormsModule,
        CommonModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
    ],
    declarations:[
        ClearanceItemTagComponent
    ],
    exports:[
        ClearanceItemTagComponent,
        // AssetManagerModule
    ]
})
export class ClearanceItemCommonModule{}